document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu?.classList.toggle('is-open', !open);
    document.body.classList.toggle('menu-open', !open);
  });
  document.querySelector('[data-locale-select]')?.addEventListener('change', (event) => event.target.form?.submit());
  const mainImage = document.querySelector('[data-product-main]');
  document.querySelectorAll('[data-product-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      if (mainImage && button.dataset.src) mainImage.src = button.dataset.src;
      document.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });
});
